import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  agaveShadowRenderCallerSchema,
  agaveShadowRenderDetailResponseSchema,
  agaveShadowRenderModeSchema,
  agaveShadowRenderProductTypeSchema,
  agaveShadowRenderStatusSchema,
  agaveShadowRendersListResponseSchema,
} from "./schemas";

const AGAVE_SHADOW_RENDERS_PAGE_SIZE = 6;

const agaveShadowRendersQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "agave", "shadow-renders", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/agave-ai-edit-shadow-renders",
  paramsSchema: z.object({
    afterCursor: z.string().optional(),
    caller: agaveShadowRenderCallerSchema.or(z.string()).optional(),
    includeProjectPlayback: z.boolean().optional().default(false),
    mode: agaveShadowRenderModeSchema.optional(),
    pageSize: z.number().max(50).optional().default(AGAVE_SHADOW_RENDERS_PAGE_SIZE),
    productType: agaveShadowRenderProductTypeSchema.or(z.string()).optional(),
    requiresSourceVideoAsset: z.boolean().optional(),
    status: agaveShadowRenderStatusSchema.optional(),
    terminalOnly: z.boolean().optional().default(true),
  }),
  responseSchema: agaveShadowRendersListResponseSchema,
});

export const fetchAgaveShadowRendersQuery = agaveShadowRendersQuery;

export const fetchAgaveShadowRendersInfiniteQuery = agaveShadowRendersQuery.withPagination({
  getNextPageParam(lastPage) {
    return lastPage.results.pageInfo.hasNextPage ? lastPage.results.pageInfo.endCursor : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: AGAVE_SHADOW_RENDERS_PAGE_SIZE,
    };
  },
});

export const getAgaveShadowRenderQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "agave", "shadow-renders", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/agave-ai-edit-shadow-renders/:shadowRenderId",
  responseSchema: agaveShadowRenderDetailResponseSchema,
});
